import { render } from "./salary-view.vue?vue&type=template&id=a3a1948c"
import script from "./salary-view.vue?vue&type=script&lang=js"
export * from "./salary-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__